/* ================================================== */
/* SLIDE FADE TOGGLE
/* ================================================== */

$.fn.slideFadeToggle = function(speed, easing, callback) {
	return this.animate({opacity: 'toggle', height: 'toggle'}, speed, easing, callback);
};

$(document).ready(function() {
	$('[data-slide-fade-toggle]').click(function() {
		var $next = $(this).next();
		$(this).toggleClass('open');
		$next.slideFadeToggle(300)
			 .attr('aria-expanded', ($next.attr('aria-expanded') == 'false') ? 'true' : 'false');
	});
})